module.exports = __webpack_public_path__ + "static/media/mod.256cd1a7.jpg";